export default "__VITE_ASSET__DwkYfD_e__"